import React from 'react';
import { Hero } from '../components/Hero';
import { Experience } from '../components/Experience';
import { Gallery } from '../components/Gallery';
import { Music } from '../components/Music';
import { Privatize } from '../components/Privatize';
import { Footer } from '../components/Footer';
export function Home() {
  return <main className="bg-obsidian min-h-screen" data-id="element-212">
      <Hero data-id="element-213" />
      <Experience data-id="element-214" />
      <Music data-id="element-215" />
      <Gallery data-id="element-216" />
      <Privatize data-id="element-217" />
      <Footer data-id="element-218" />
    </main>;
}